import { Injectable } from '@angular/core';
import { _HttpClient } from '@delon/theme';

@Injectable()
export class PurchaseDocTransferService {
  constructor(private http: _HttpClient) {}

  url = 'api/PurchaseTransfers/GetOutstandingDocs?_silent=true';
  loading = false;

  private _outstandingDocs: any[] = [];
  get outstandingDocs() {
    return this._outstandingDocs;
  }
  set outstandingDocs(val: any[]) {
    this._outstandingDocs = val;
  }

  reload(docType: string, supplierId: any, transferredDocIds: string[], dateFrom: Date, dateTo: Date, docFrom: string, docTo: string, transferToDocCode: string) {
    const params: any = {
        docType: docType,
        supplierId: supplierId,
        transferredDocIds: transferredDocIds,
        docDateFrom: dateFrom,
        docDateTo: dateTo,
        docCodeFrom: docFrom,
        docCodeTo: docTo,
    };
    if (params.docType && (params.docType === 'CP' ? params.docType === 'CP' : params.supplierId)) {
      this.http.post(this.url, params).subscribe(res => {
        this.outstandingDocs = [...res];
      });
    }
    else {
      this.outstandingDocs = [];
    }
  }
}
